const RealtimeReminderConfig = () =>
  import(
    '@/views/main/wechatMgmt/realtimeReminderConfig/RealtimeReminderConfig.vue'
  )

export default {
  path: '/main/wechatMgmt/realtimeReminderConfig',
  name: 'RealtimeReminderConfig',
  component: RealtimeReminderConfig
}
